module.exports = __webpack_public_path__ + "img/mille.5e6ddd88.jpg";